<div class="flex vcenter">
  <payee-form-field>
    <input
      type="text"
      payee-input
      placeholder="Ügy iktatószáma"
      [formControl]="searchControl"
    />
  </payee-form-field>
  @if (loading()) {
    <mat-progress-spinner
      mode="indeterminate"
      diameter="24"
    ></mat-progress-spinner>
  }
</div>

<table
  mat-table
  multiTemplateDataRows
  matSort
  class="mat-elevation-z1 top-margin-15"
  id="invoice-table"
  [dataSource]="dataSource"
  [matSortDisabled]="loading()"
  (matSortChange)="sortChange()"
>
  <ng-container matColumnDef="invoice_number">
    <th
      *matHeaderCellDef
      mat-header-cell
      mat-sort-header
    >
      Számla Azonosító
    </th>
    <td
      *matCellDef="let element"
      mat-cell
    >
      {{ element.invoice.invoice_number }}
    </td>
  </ng-container>

  <ng-container matColumnDef="remaining_amount">
    <th
      *matHeaderCellDef
      mat-header-cell
      mat-sort-header
    >
      Számla Összege
    </th>
    <td
      *matCellDef="let element"
      mat-cell
    >
      <span>{{ element.invoice.remaining_amount | number: "1.0" : "hu" }}&nbsp;{{ element.invoice.currency_iso }}</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="due_date_at">
    <th
      *matHeaderCellDef
      mat-header-cell
      mat-sort-header
    >
      Fizetési Határidő
    </th>
    <td
      *matCellDef="let element"
      mat-cell
    >
      {{ element.invoice.due_date_at | date: "yyyy.MM.dd." }}
    </td>
  </ng-container>

  <!-- Expanded Content Column -->
  <ng-container matColumnDef="expandedDetail">
    <td
      *matCellDef="let element"
      mat-cell
      [attr.colspan]="displayedColumns.length"
    >
      @if (expandedElement === element) {
        <div class="detail-column">
          <section class="main-invoice">
            <h1>Főszámla</h1>
            <div class="invoice-data-entry-row">
              <div class="invoice-data-title">Azonosító:</div>
              <div class="invoice-data-value">
                {{ element.invoice.invoice_number }}
              </div>
            </div>
            <div class="invoice-data-entry-row">
              <div class="invoice-data-title">Számla Összege:</div>
              <div class="invoice-data-value">
                {{ element.invoice.remaining_amount | number: "1.0" : "hu" }}
                {{ element.invoice.currency_iso }}
              </div>
            </div>
            <div class="invoice-data-entry-row">
              <div class="invoice-data-title">Fizetési Határidő:</div>
              <div class="invoice-data-value">
                {{ element.invoice.due_date_at | date: "yyyy.MM.dd." }}
              </div>
            </div>
            <div class="invoice-data-entry-row">
              <div class="invoice-data-title">Kelte:</div>
              <div class="invoice-data-value">
                {{ element.invoice.issued_at | date: "yyyy.MM.dd." }}
              </div>
            </div>
          </section>
          @if (element.corrections.length > 0) {
            <section class="correction-invoices">
              <h1>Helyesbítő számlák</h1>
              @for (correction of element.corrections; track correction.invoice_number; let i = $index) {
                <section class="correction-invoice">
                  <h2>{{ i + 1 }}. Helyesbítő számla</h2>
                  <div class="invoice-data-entry-row">
                    <div class="invoice-data-title">Azonosító:</div>
                    <div class="invoice-data-value">
                      {{ correction.invoice_number }}
                    </div>
                  </div>
                  <div class="invoice-data-entry-row">
                    <div class="invoice-data-title">Számla Összege:</div>
                    <div class="invoice-data-value">
                      {{ correction.remaining_amount | number: "1.0" : "hu" }}
                      {{ correction.currency_iso }}
                    </div>
                  </div>
                  <div class="invoice-data-entry-row">
                    <div class="invoice-data-title">Fizetési Határidő:</div>
                    <div class="invoice-data-value">
                      {{ correction.due_date_at | date: "yyyy.MM.dd." }}
                    </div>
                  </div>
                  <div class="invoice-data-entry-row">
                    <div class="invoice-data-title">Kelte:</div>
                    <div class="invoice-data-value">
                      {{ correction.issued_at | date: "yyyy.MM.dd." }}
                    </div>
                  </div>
                </section>
              }
            </section>
          }
        </div>
      }
    </td>
  </ng-container>

  <tr
    *matHeaderRowDef="displayedColumns"
    mat-header-row
  ></tr>
  <tr
    *matRowDef="let element; columns: displayedColumns"
    mat-row
    class="element-row"
    (click)="toggleExpandedElement(element)"
  ></tr>
  <tr
    *matRowDef="let row; columns: ['expandedDetail']"
    mat-row
    class="detail-row"
    [class.expanded-row]="expandedElement === row"
  ></tr>
</table>

<mat-paginator
  showFirstLastButtons
  class="mat-elevation-z1"
  [disabled]="loading()"
  [pageSize]="pageSize"
  [pageIndex]="pageIndex"
  [pageSizeOptions]="[5, 10, 25, 100]"
  [length]="length"
  (page)="pageChange($event)"
></mat-paginator>
